import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { homeSeo, articleSeo, LANG_CODES } from "./data";
import { applySeo, applyNoIndex, type ResolvedSeo } from "./meta";
import { applyHomeJsonLd, applyArticleJsonLd } from "./jsonLd";

function titleFromSlug(slug: string): string {
  return (
    slug
      .split("-")
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ") + " — AllChinaBuy Guide"
  );
}

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const segments = path.split("/").filter(Boolean);

    // Home page
    if (segments.length === 0) {
      const seo: ResolvedSeo = { ...homeSeo, type: "website" };
      applySeo(seo);
      applyHomeJsonLd(seo.description);
      return;
    }

    // Article: /:slug or /:lang/:slug
    let slug: string | null = null;
    let lang = "en";
    if (segments.length === 1) {
      slug = segments[0];
    } else if (segments.length === 2 && LANG_CODES.includes(segments[0])) {
      lang = segments[0];
      slug = segments[1];
    }

    if (slug) {
      const known = articleSeo[slug];
      const title = known?.title ?? titleFromSlug(slug);
      const description =
        known?.description ??
        `Explore the AllChinaBuy ${slug
          .split("-")
          .join(" ")} guide with practical tips, product finds and buying advice for international shoppers.`;
      const keywords =
        known?.keywords ?? "AllChinaBuy, AllChinaBuy spreadsheet, AllChinaBuy guide";

      const seo: ResolvedSeo = {
        title,
        description,
        keywords,
        path,
        type: "article",
      };
      applySeo(seo);
      applyArticleJsonLd(seo, lang);
      return;
    }

    // Unknown / 404 — never index
    applyNoIndex("Page Not Found");
  }, [location.pathname]);

  return null;
}